import type { ProjectNote } from '@/api/client';

export const TEMP_NOTE_PREFIX = 'temp-';

/** Заметка создана не более чем 48 часов назад */
export function isRecentlyAdded(createdAt: string | undefined): boolean {
  if (!createdAt) return false;
  try {
    const created = new Date(createdAt).getTime();
    const now = Date.now();
    return (now - created) / (1000 * 60 * 60) < 48;
  } catch {
    return false;
  }
}

export function isTempNote(noteId: string): boolean {
  return noteId.startsWith(TEMP_NOTE_PREFIX);
}

/** Количество «новых» заметок (сохранённые, созданные за последние 48 ч) */
export function countNewNotes(notes: ProjectNote[] | undefined): number {
  if (!notes?.length) return 0;
  return notes.filter(
    (n) => !isTempNote(n.note_id) && isRecentlyAdded(n.created_at)
  ).length;
}
